import { marked } from 'marked';

/**
 * Markdown到HTML转换函数（使用 marked 库）
 * @param markdown - Markdown文本
 * @returns HTML字符串
 */
export const markdownToHtml = (markdown: string): string => {
  if (!markdown) return '';

  try {
    // 使用 marked 解析 markdown
    let html = marked.parse(markdown, {
      breaks: true, // 支持换行
      gfm: true, // 支持 GitHub Flavored Markdown（包括表格）
    }) as string;

    // 添加自定义样式类
    // 标题样式
    html = html
      .replace(/<h1>/g, '<h1 class="text-xl font-bold text-white mt-6 mb-4">')
      .replace(/<h2>/g, '<h2 class="text-lg font-bold text-white mt-5 mb-3 border-b border-white/20 pb-2">')
      .replace(/<h3>/g, '<h3 class="text-base font-semibold text-white mt-4 mb-2">')
      .replace(/<h4>/g, '<h4 class="text-sm font-semibold text-white mt-3 mb-2">')
      // 段落样式
      .replace(/<p>/g, '<p class="text-white/80 mb-2 leading-relaxed">')
      // 列表样式
      .replace(/<ul>/g, '<ul class="list-none space-y-1 mb-3 ml-2">')
      .replace(/<ol>/g, '<ol class="list-decimal list-inside space-y-1 mb-3 ml-2">')
      .replace(/<li>/g, '<li class="text-white/80 ml-4 mb-1">');

    // 代码块样式（限制高度并添加滚动）
    // 先处理代码块（pre > code 结构），限制高度并添加滚动
    html = html.replace(/<pre><code(?: class="([^"]*)")?>(.*?)<\/code><\/pre>/gs, (_, codeClass, codeContent) => {
      return `<pre class="bg-gray-800 rounded-lg p-4 my-4 overflow-x-auto"><code class="${codeClass}">${codeContent}</code></pre>`;
    });

    // 再处理行内代码：移除所有 code 标签上的 class 属性，然后为行内代码添加样式
    // 注意：代码块中的 code 标签已经被替换，所以这里只会匹配到行内代码
    html = html.replace(/<code(?: class="[^"]*")?>/g, '<code class="bg-white/10 px-1 py-0.5 rounded text-xs">');

    // 继续添加其他样式
    html = html
      // 链接样式
      .replace(
        /<a href=/g,
        '<a class="text-cyan-400 hover:text-cyan-300 underline" target="_blank" rel="noopener noreferrer" href=',
      )
      // 表格样式
      .replace(/<table>/g, '<table class="w-full border-collapse border border-white/20 my-4">')
      .replace(/<thead>/g, '<thead>')
      .replace(/<th>/g, '<th class="border border-white/20 px-3 py-2 text-left font-semibold text-white bg-white/5">')
      .replace(/<td>/g, '<td class="border border-white/20 px-3 py-2 text-white/80">')
      // 水平线样式
      .replace(/<hr>/g, '<hr class="border-white/20 my-4">')
      // 粗体和斜体样式
      .replace(/<strong>/g, '<strong class="font-semibold text-white">')
      .replace(/<em>/g, '<em class="italic text-white/90">');

    return html;
  } catch (error) {
    console.error('Markdown 解析失败:', error);
    return markdown; // 解析失败时返回原始文本
  }
};
